import { render, staticRenderFns } from "./Drawers.vue?vue&type=template&id=18502302"
import script from "./Drawers.vue?vue&type=script&lang=ts"
export * from "./Drawers.vue?vue&type=script&lang=ts"
import style0 from "./Drawers.vue?vue&type=style&index=0&id=18502302&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports